module.exports = __webpack_public_path__ + "static/media/approval-policy.9d7a1fae.svg";